import React from "react";

// Seo.jsx (React 19) — com suporte a noindex, OG e Twitter
export default function Seo({
  title,
  description,
  canonical,
  ogImage,
  noindex = false,
  siteName = "LesVita",
}) {
  const robots = noindex ? "noindex, nofollow, noarchive" : "index, follow";
  return (
    <>
      {/* Básico */}
      {title && <title>{title}</title>}
      {description && <meta name="description" content={description} />}
      {canonical && <link rel="canonical" href={canonical} />}
      <meta name="robots" content={robots} />

      {/* Open Graph */}
      {title && <meta property="og:title" content={title} />}
      {description && <meta property="og:description" content={description} />}
      {ogImage && <meta property="og:image" content={ogImage} />}
      {canonical && <meta property="og:url" content={canonical} />}
      <meta property="og:site_name" content={siteName} />
      <meta property="og:type" content="website" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      {title && <meta name="twitter:title" content={title} />}
      {description && <meta name="twitter:description" content={description} />}
      {ogImage && <meta name="twitter:image" content={ogImage} />}

      {/* Sinalização de noindex específica para bots (redundância útil) */}
      {noindex && <meta name="googlebot" content="noindex, nofollow" />}
      {noindex && <meta name="bingbot" content="noindex, nofollow" />}
    </>
  );
}
